<template>
  <v-container>
    <!-- ทำงานตอนบันทึกข้อมูล -->
    <v-dialog v-model="loading_download" hide-overlay persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1">
        <v-card-text class="text-center">
          กำลังบันทึกข้อมูล
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="align-center pt-2">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >สรุปผลการตรวจและข้อเสนอแนะนำในการปฏิบัติตนประจำปี
        {{ this.year ? this.year : "" }}</span
      >
    </div>
    <v-row>
      <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
        <!-- <v-col cols="12" class="mt-2">
          <span style="font-size: 16px; font-weight: bold">1. ตรวจร่างกาย </span
          ><span>- {{ resultTemplate("general_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >2. สรุปผลการตรวจความสมบูรณ์ของเม็ดเลือด </span
          ><span>- {{ resultTemplate("blood_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >3. สรุปผลการตรวจปัสสาวะ </span
          ><span>- {{ resultTemplate("urine_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >4. ผลการตรวจเอ็กซเรย์ทรวงอก (Chest X-ray) </span
          ><span>- {{ resultTemplate("x_ray_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold">5. การมองเห็น </span
          ><span>- {{ resultTemplate("vision_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >6. ความดันและชีพจร </span
          ><span>- {{ resultTemplate("pressure_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >7. ตรวจไวรัสตับอักเสบ บี </span
          ><span>- {{ resultTemplate("b_virus_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >8. ตรวจระดับไขมัน HDL </span
          ><span>- *{{ resultTemplate("hdl_status") || "ไม่ทราบผล" }}</span>
        </v-col>
        <v-col cols="12">
          <span style="font-size: 16px; font-weight: bold"
            >9.ตรวจระดับไขมัน LDL </span
          ><span>- *{{ resultTemplate("ldl_status") || "ไม่ทราบผล" }}</span>
        </v-col> -->
        <v-col cols="12" class="d-flex justify-end mt-2">
          <v-btn
            @click="addText()"
            color="#00A99D"
            style="color: white; width: 150px;"
            ><v-icon class="mr-2">mdi-plus</v-icon
            >เพิ่มผลการสรุป</v-btn
          >
        </v-col>
        <div v-for="(item, index) in summary" :key="index" class="d-flex">
          <div style="width: 10%; padding-top: 3px;" class="d-flex justify-center align-start">{{ index+1 }}</div>
          <div style="width: 80%;">
            <v-textarea
                v-model="summary[index]"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลการสรุป"
                class="ma-2 textfield-sty"
                color="#00A99D"
                rows="3"
              ></v-textarea>
          </div>
          <div style="width: 10%; padding-top: 3px;" class="d-flex justify-center align-start">
            <v-btn
              icon
              @click="removeText(index)"
              color="#00A99D"
              style="color: white;"
              v-if="index > 0"
              >
                <v-icon color="red">
                  mdi-delete
                </v-icon>
              </v-btn>
          </div>
        </div>
        <v-col cols="12">
          <span style="font-size: 16px; color: #00a99d"
            >แนะนำปรึกษาแพทย์และตรวจสุขภาพเป็นประจำทุกปี</span
          >
        </v-col>
      </v-col>

      <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
        <v-col cols="12" xs="12" sm="12" md="8" lg="6" xl="6">
          <span style="font-size: 16px">
            แพทย์ <span style="color: red">*</span>
          </span>
          <v-combobox
            attach
            v-model="select_doc"
            placeholder="ชื่อแพทย์"
            :item="searchDoc"
            outlined
            dense
            hide-details
            :items="searchDoc"
            @input="searchDoctor"
            item-text="name_th"
            return-object
            class="mt-1"
            :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
            color="#00A99D"
          >
            <template v-slot:append>
              <img src="@/assets/icon/medcert/search.svg" alt="search" />
            </template>
          </v-combobox>
        </v-col>
        <v-col>
          <v-btn
            @click="save_data()"
            :disabled="select_doc.length === 0 || !select_doc || select_doc === undefined || !select_doc.one_id"
            color="#00A99D"
            style="color: white;"
            class="card-medium"
            ><v-icon class="mr-2">mdi-arrow-down</v-icon
            >บันทึกผลการตรวจสุขภาพ</v-btn
          >
        </v-col>
      </v-col>
    </v-row>
    <!-- <div style="margin-left: 50%; margin-top: 8%">
      <v-col cols="12"
        ><v-img style="margin-left: 14%">****ลายเซ็น****</v-img></v-col
      ><v-col cols="12"
        ><v-span style="color: #2f80ed; font-size: 20px"
          >นายแพทย์ ขอไข่ อร่อยจัง (ว. xxxxx)</v-span
        ></v-col
      ><v-col cols="12" class="pt-0"
        ><v-span style="font-size: 16px; margin-left: 12%"
          >แพทย์อาชีวเวชศาสตร์</v-span
        ></v-col
      >
    </div> -->

    <PreviewPDF ref="preview_pdf" @goBack="goBack()" />

    <!-- ----------------- -->
  </v-container>
</template>

<script>
import { EventBus } from "../../EventBus";
import PreviewPDF from "./PreviewPDF.vue";

export default {
  components: {
    PreviewPDF,
  },
  data() {
    return {
      dataAll_eventBus: [],
      year: "",
      dataAll_forDownload: [],
      overlay: false,
      role: "",
      searchDoc: [],
      select_doc: [],
      is_select_doc: true,
      loading_download: false,
      cid: "",
      // summary: [
      //   {
      //     general_status: "",
      //   },
      //   {
      //     blood_status: "",
      //   },
      //   {
      //     urine_status: "",
      //   },
      //   {
      //     x_ray_status: "",
      //   },
      //   {
      //     vision_status: "",
      //   },
      //   {
      //     pressure_status: "",
      //   },
      //   {
      //     b_virus_status: "",
      //   },
      //   {
      //     hdl_status: "",
      //   },
      //   {
      //     ldl_status: "",
      //   },
      // ],
      summary: [
        ""
      ]
    };
  },
  created() {
    this.detailAll();
    this.role = sessionStorage.role_name;
  },
  computed: {
    check_role() {
      return this.role === "แพทย์";
    },
  },
  watch: {
    select_doc: {
      handler(new_val) {
        if (new_val === null || new_val === "") {
          this.is_select_doc = true;
        } else {
          this.is_select_doc = false;
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getStaff();
  },
  methods: {
    goBack () {
      this.$emit("goBack")
    },
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", (item) => {
        if (item !== undefined && item !== null) {
          if (item.send_data){
            this.dataAll_forDownload = item;
          }
          this.cid = item.cid
          this.summary = item.summary
          this.dataAll_eventBus = item.summary;
          this.select_doc = item.doctor ? item.doctor : []
          this.dataAll_forDownload["doctor"] = this.select_doc
          this.year = parseInt(item.year, 10) + 543;
        } else {
          this.dataAll_eventBus = [];
          this.year = "";
        }
      });
      EventBus.$on("detailAll_GetOneFormPost", (item) => {
        if (item !== undefined && item !== null) {
          this.cid = item.cid
          this.dataAll_forDownload = item;
        } else {
          this.dataAll_forDownload = [];
        }
      });
    },
    resultTemplate(key) {
      if (this.dataAll_eventBus[0] != undefined) {
        if (key == "general_status") {
          // console.log(this.summary[0].general_status);
          this.summary[0].general_status = this.dataAll_eventBus[0]
            .general_status
            ? this.dataAll_eventBus[0].general_status
            : "";
          return this.dataAll_eventBus[0].general_status
            ? this.dataAll_eventBus[0].general_status
            : "";
        }
        if (key == "blood_status") {
          this.summary[1].blood_status = this.dataAll_eventBus[1].blood_status
            ? this.dataAll_eventBus[1].blood_status
            : "";
          return this.dataAll_eventBus[1].blood_status
            ? this.dataAll_eventBus[1].blood_status
            : "";
        }
        if (key == "urine_status") {
          this.summary[2].urine_status = this.dataAll_eventBus[2].urine_status
            ? this.dataAll_eventBus[2].urine_status
            : "";
          return this.dataAll_eventBus[2].urine_status
            ? this.dataAll_eventBus[2].urine_status
            : "";
        }
        if (key == "x_ray_status") {
          this.summary[3].x_ray_status = this.dataAll_eventBus[3].x_ray_status
            ? this.dataAll_eventBus[3].x_ray_status
            : "";
          return this.dataAll_eventBus[3].x_ray_status
            ? this.dataAll_eventBus[3].x_ray_status
            : "";
        }
        if (key == "vision_status") {
          this.summary[4].vision_status = this.dataAll_eventBus[4].vision_status
            ? this.dataAll_eventBus[4].vision_status
            : "";
          return this.dataAll_eventBus[4].vision_status
            ? this.dataAll_eventBus[4].vision_status
            : "";
        }
        if (key == "pressure_status") {
          this.summary[5].pressure_status = this.dataAll_eventBus[5]
            .pressure_status
            ? this.dataAll_eventBus[5].pressure_status
            : "";
          return this.dataAll_eventBus[5].pressure_status
            ? this.dataAll_eventBus[5].pressure_status
            : "";
        }
        if (key == "b_virus_status") {
          this.summary[6].b_virus_status = this.dataAll_eventBus[6]
            .b_virus_status
            ? this.dataAll_eventBus[6].b_virus_status
            : "";
          return this.dataAll_eventBus[6].b_virus_status
            ? this.dataAll_eventBus[6].b_virus_status
            : "";
        }
        if (key == "hdl_status") {
          this.summary[7].hdl_status = this.dataAll_eventBus[7].hdl_status
            ? this.dataAll_eventBus[7].hdl_status
            : "";
          return this.dataAll_eventBus[7].hdl_status
            ? this.dataAll_eventBus[7].hdl_status
            : "";
        }
        if (key == "ldl_status") {
          this.summary[8].ldl_status = this.dataAll_eventBus[8].ldl_status
            ? this.dataAll_eventBus[8].ldl_status
            : "";
          return this.dataAll_eventBus[8].ldl_status
            ? this.dataAll_eventBus[8].ldl_status
            : "";
        }
      }
    },
    async save_data() {
      try {
        this.dataAll_forDownload.doctor = this.select_doc
        this.dataAll_forDownload.summary = this.summary
        await this.addForm()
        // this.loading_download = true;
        let payload = this.dataAll_forDownload;
        payload["create_by"] = sessionStorage.getItem("role_name")
        payload.labResult.bloodGroupDetection.bloodGroup.result = payload.labResult.bloodGroupDetection.bloodGroup.result.toString()
        this.$swal
          .fire({
            icon: "warning",
            title: `<span style='font-size: 20px;font-family: Sarabun, sans-serif;'>ยืนยันการบันทึกข้อมูล ${
              this.check_role ? "และเซ็นเอกสารหรือไม่" : ""
            } </br> <span style='font-size: 18px; font-family: Sarabun, sans-serif;'>ข้อมูลจะถูกบันทึกเมื่อกด 'ยืนยัน'</span> </span>`,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: "#00A99D",
            reverseButtons: true,
            cancelButtonText:
              "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยกเลิก</span>",
            cancelButtonColor: "#F5222D",
            confirmButtonText:
              "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
            returnEmit: "confirm",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              this.loading_download = true;
              this.overlay = true;
              // this.dataAll_forDownload["doctor"] = this.select_doc
              // await this.addForm()
              console.log("payloadpayloadpayload", payload);
              
              // console.log("add form", this.dataAll_forDownload["doctor"])
              // console.log("add form2", this.select_doc)
              this.axios
                .post(
                `${process.env.VUE_APP_BACKEND_URL}/v2/sign/create-pdf`,
                  payload,
                )
                .then((res) => {
                  this.loading_download = false;
                  this.$swal
                    .fire({
                      icon: "success",
                      title: "บันทึกข้อมูลสำเร็จ",
                      showConfirmButton: false,
                      timer: 1000,
                    })
                    .then(() => {
                      this.$refs.preview_pdf.open(
                        res.data.data,
                        payload,
                        "HEALTH_CHECK"
                      );
                    });
                })
                .catch((err) => {
                  this.loading_download = false;
                  console.log("axios save data err:", err.message);
                  this.$swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                });
            }
          });
      } catch (error) {
        this.loading_download = false;
        console.log("function download pdf data error:", error);
        this.$swal.fire({
          icon: "error",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
    async getStaff() {
      try {
        let params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("mode", "all-doctor");
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/getStaff?${params}`)
          .then((res) => {
            // console.log(">>> res", res, " ---------------")

            this.searchDoc = res.data.data;
          });
      } catch (err) {
        console.log(err);
      }
    },
    searchDoctor() {
      if (this.is_select_doc) {
        this.dataAll_forDownload["doctor"] = {
          biz_id: this.select_doc.biz_id,
          doctor_license: this.select_doc.doctor_license,
          name_th: this.select_doc.name_th,
          one_id: this.select_doc.one_id,
        };
      }
    },
    async addForm () {
      await this.$emit("add_form")
    },
    addText () {
      this.summary.push("")
    },
    removeText (index) {
      this.summary.splice(index, 1)
    }
    // downloadData() {
    //   const data = this.dataAll_forDownload;
    //   const url = `${process.env.VUE_APP_BACKEND_URL}/v1/sign/create-pdf`; //  URL ต้องการดาวน์โหลด
    //   const options = {
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.access_token}`,
    //       "Content-Type": "application/json",
    //       "Content-Disposition": 'attachment; filename="file.pdf"',
    //     },
    //     responseType: "blob",
    //   };
    //   this.axios
    //     .post(url, data, options)
    //     .then((response) => {
    //       const blob = new Blob([response.data], { type: "application/pdf" });
    //       const link = document.createElement("a");
    //       link.href = URL.createObjectURL(blob);
    //       link.download = "รายงานผลการตรวจร่างกายเบื้องต้น.pdf"; // ตั้งชื่อไฟล์ที่จะดาวน์โหลด
    //       link.click();
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //       this.$swal.fire("ผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
    //     });
    // },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
    EventBus.$off("detailAll_GetOneFormPost", this.detailPhysicalExam);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.textfield-sty {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.btn-sty {
  border-radius: 10px;
}
.text-cennter {
  text-align: center;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.v-select.v-text-field:not(.v-text-field--single-line) input {
  line-height: 1.7;
}
.v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.7rem;
}
</style>
